import React from "react";

import SelectDateInform from "./../componentes/SelectDateInform";
// import InformGenerated from "./../componentes/InformGenerated";
import Inform from './Infrom'

import { sendService, answerOk } from "./../../Services/service";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sessionActs from "./../../Actions/Session";
import * as modalActs from "./../../Actions/Modal";

import "./../inform.css";

class InitInform extends React.Component {
  state = {
    data: {},
    type: "",
    time: "",
    zone: "",
    generated: false,
    error: null,
    showRange: false,
    dateRange0: 0,
    dateRange1: 0,
  };

  handlerChangeDate = (event) => {
    let str = event.target.value.split("-");
    let fecha = new Date(str[0], Number(str[1]) - 1, str[2]);
    this.setState({ [event.target.id]: fecha.getTime() });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value, error: null });
    if (event.target.name === "time") {
      if (event.target.value === 0) {
        this.setState({ showRange: true });
      } else {
        this.setState({ showRange: false });
      }
    }
  };

  async componentDidMount() {
    // const url = "/api/v1/informs/weekly/1641013200000/1643605200000/0";
    // this.props.modalActions.openLoader();
    // const resp = await sendService(url, "POST");
    // this.props.modalActions.closeLoader();
    // if (
    //   !answerOk(resp, () => {
    //     this.props.sessionActions.closeSession();
    //     this.props.modalActions.openLoader();
    //   })
    // )
    //   return;
    // this.setState({ data: resp.response, generated: true });
    // console.log(resp)
  }

  handlerSave = () => {
    if (
      this.state.type === "" ||
      this.state.time === "" ||
      this.state.zone === ""
    ) {
      this.setState({ error: "* Seleccione los campos requeridos" });
      return;
    }
    if (this.state.showRange) {
      console.log("validar date");
    }
    this.props.modalActions.openLoader();
    this.setState({ error: null, generated: true });
    this.props.modalActions.closeLoader();
  };

  handlerCancel = () => {
    this.props.onChangeRoute("/");
  };

  handlerGenerate = async () => {
    if (this.state.time === 0) {
      if (this.state.dateRange0 === 0 || this.state.dateRange1 === 0) {
        this.setState({ error: "* Seleccione las fechas" });
        return;
      }
      if (this.state.dateRange0 >= this.state.dateRange1) {
        this.setState({
          error: "* La fecha inicial debe ser menor a la fecha final.",
        });
        return;
      }
    } else if (this.state.time === "") {
      this.setState({ error: "* Seleccione un periodo de tiempo" });
      return;
    }

    const url =
      "/api/v1/informs/weekly/" +
      this.state.dateRange0 +
      "/" +
      this.state.dateRange1 +
      "/" +
      this.state.time;
    this.props.modalActions.openLoader();
    const resp = await sendService(url, "POST");
    console.log(resp);

    this.props.modalActions.closeLoader();
    if (
      !answerOk(resp, () => {
        this.props.sessionActions.closeSession();
        this.props.modalActions.openLoader();
      })
    )
      return;
    this.setState({ data: resp.response, generated: true });
  };

  cancel = () => {
    this.setState({ generated: false });
  };

  render() {
    return (
      <React.Fragment>
        {this.state.generated ? (
          <Inform
            data={this.state.data}
            onCancel={this.cancel}
            zone={1}
            onSave={this.savePdf}
            result={this.props.result}
          />
        ) : (
          <SelectDateInform
            onGenerate={this.handlerGenerate}
            error={this.state.error}
            onSelectTime={this.handleChange}
            onSelectZone={this.handleChange}
            onChangeDate={this.handlerChangeDate}
            onSave={this.handlerSave}
            onCancel={this.handlerCancel}
            state={this.state}
            showRange={this.state.showRange}
          />
        )}
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    sessionActions: bindActionCreators(sessionActs, dispatch),
    modalActions: bindActionCreators(modalActs, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(InitInform);
